import fetcher from '@/services/fetcher'
import type { DailyGameStateResponse } from '@/types'
import { toPortalUrl } from '@/utils/url-generation-utils'
import type { NavigationGuardNext, RouteLocation } from 'vue-router'
import { useToast } from 'vue-toastification'

/**
 * Validates daily game state before entering daily spins routes.
 * Shows toast error and redirects to home if game is unavailable.
 */
export default async function fetchDailyGameState(
  to: RouteLocation,
  _from: RouteLocation,
  next: NavigationGuardNext
) {
  const toast = useToast()

  try {
    // Check game state
    const { data, error } = await fetcher.get<DailyGameStateResponse>(
      toPortalUrl('/daily-game/state')
    )

    if (error.value) {
      // Extract error message from backend response
      const errorMessage =
        error.value?.error ||
        error.value?.message ||
        'Our apologies. There is no active game at the moment'

      if (!errorMessage.includes('Unauthenticated')) {
        toast.error(errorMessage)
      }
      return next({ name: 'home' })
    }

    const gameState = data.value?.csi_content.data

    // Store game state in route meta for component to use
    to.meta.props = { gameState }

    next()
  } catch (error) {
    console.error('Failed to validate daily game state:', error)
    toast.error('Our apologies. There is no active game at the moment')
    return next({ name: 'home' })
  }
}
